var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"AggypjO_uoM300D0cwhX9"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/builds/prod/21740509311_3959_20260206T060033";

import { convert } from '@revenuemarket/utils';
import * as Sentry from '@sentry/nextjs';
import { getCookie } from 'cookies-next';

import { deserializeAccessToken } from '~utils/auth';

Sentry.init({
  dsn: 'https://fd1faa5f2d6b45dbbe0d55a832bbfb27@o4504325876547584.ingest.sentry.io/4504325877334016',
  release: process.env.RELEASE_ID,
  environment: process.env.APP_ENV,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  ignoreErrors: [/Network Error/i],
  beforeSend(event) {
    // Set company ID role from token
    const accessToken = convert(getCookie('accessToken'), String);
    if (accessToken) {
      const decodedToken = deserializeAccessToken(accessToken);

      if (decodedToken?.companyIdRole?.id) {
        event.tags = {
          ...event.tags,
          companyId: decodedToken.companyIdRole.id,
        };
      }
    }

    if (event.exception && event.exception.values) {
      const errorMessage = event.exception.values[0].value;
      if (
        ['Invariant: attempted to hard navigate to the same', 'Request aborted'].some(
          (ignoreMessage) => errorMessage.includes(ignoreMessage),
        )
      ) {
        return null;
      } else {
        return event;
      }
    }
    return event;
  },
  tracesSampler: (samplingContext) => {
    if (samplingContext.transactionContext.name.includes('/signin')) {
      return 1;
    }
    return 0.2;
  },
  profilesSampleRate: 0.2,
  enabled: Boolean(process.env.APP_ENV) && process.env.APP_ENV !== 'local',
});

Sentry.setTag('role', 'service');
